import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from '../../../utils/actionGenerator';

export const PTL_FREIGHT_UPLOAD = createRequestTypes('PTL_FREIGHT_UPLOAD');

export const postPTLFreightUpload = {
  request: (payload,freightType) => createAction(PTL_FREIGHT_UPLOAD[REQUEST], { payload,freightType }),
  success: (response) => createAction(PTL_FREIGHT_UPLOAD[SUCCESS], { response }),
  failure: (response) => createAction(PTL_FREIGHT_UPLOAD[FAILURE], { response }),
};